// События квиза дня по словарю аналитики (HQ-2313, «События»): quiz_open {from}, quiz_answer {kind, correct},
// quiz_complete {score, streak, expert_awarded}. Отдельно от экрана: вход из шапки (AppBar) не тянет чанк экрана.
import { track } from '../../analytics/track';
import type { QuizAnswerResponse, QuizResult, QuizToday } from '../../api/quizTypes';

/** Откуда открыт квиз: пока единственный вход — кнопка шапки вкладки. */
export const trackQuizOpen = (from: 'header') => track('quiz_open', { from });

/** correct — 0/1: в словаре нет логического типа, флаги — int 0/1 (как is_new). */
export const trackQuizAnswer = (kind: string, correct: boolean) => track('quiz_answer', { kind, correct: correct ? 1 : 0 });

export const trackQuizComplete = (result: QuizResult) =>
  track('quiz_complete', { score: result.score, streak: result.streak.current, expert_awarded: result.expert_awarded });

/** События принятого ответа: quiz_answer — только на первый ответ вопроса (повтор того же ответа после обрыва связи —
 *  не новый ответ), quiz_complete — когда ответ закрыл набор. */
export function trackAnswered(answer: QuizAnswerResponse, before: QuizToday | undefined): void {
  const question = before?.questions.find((q) => q.id === answer.question_id);
  if (question?.answered_option_id) return;
  trackQuizAnswer(question?.kind ?? 'unknown', answer.correct);
  if (answer.result && before?.state !== 'done') trackQuizComplete(answer.result);
}
